import { Capacitor } from '@capacitor/core'

/**
 * Base URL para la API.
 *
 * - En navegador (web servida por el manager Express, p. ej. /)
 *   usamos rutas RELATIVAS ('/api') para que apunten al mismo origen
 *   que sirve la página, sea localhost o dev.techkovery.eu.
 *
 * - En la app nativa (Capacitor) el WebView carga assets desde un esquema
 *   interno (capacitor://localhost), así que NECESITA URL absoluta.
 *   Se inyecta vía VITE_API_URL en build time:
 *     - .env.development      -> http://192.168.1.100:3001/api
 *     - .env.production       -> https://dev.techkovery.eu/api
 *     - .env.production.local -> sobrescribe sin commit (opcional)
 */
export const API_BASE = Capacitor.isNativePlatform()
    ? (import.meta.env.VITE_API_URL ?? '/api')
    : '/api'
